import { createAction, props } from "@ngrx/store";
import { IResponseAnagrafica } from "../../interfaces/anagrafica";
import { IPayloadCambioPassword, IResponseCambioPassword } from "../../interfaces/cambio-password";
import { IPayloadPutOrari, IResponseOrariChiusure } from "../../interfaces/orari-chiusure";
import { IPayloadBacheca, IResponseBacheca } from "../../interfaces/bacheca";


export const ANAGRAFICA = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - anagrafica'
);

export const ANAGRAFICA_SUCCESS = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - anagrafica success',
  props<{ responseAnagrafica: IResponseAnagrafica | null }>()
);

export const CAMBIO_PASSWORD = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - cambio password',
  props<{payload: IPayloadCambioPassword}>()
);

export const CAMBIO_PASSWORD_SUCCESS = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - cambio password success',
  props<{ responseCambioPassword: IResponseCambioPassword | null }>()
);

export const ORARI_CHIUSURE = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - orari chiusure'
);

export const ORARI_CHIUSURE_SUCCESS = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - orari chiusure success',
  props<{ responseOrariChiusure: IResponseOrariChiusure | null }>()
);

export const ORARI_CHIUSURE_PUT = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - orari chiusure put',
  props<{payload: IPayloadPutOrari}>()
);

export const ORARI_CHIUSURE_PUT_SUCCESS = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - orari chiusure put success',
  props<{ responseOrariChiusurePut: IResponseOrariChiusure | null }>()
);

export const GET_BOARD_LIST = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - get board list',
  props<{payload: IPayloadBacheca}>()
);

export const GET_BOARD_LIST_SUCCESS = createAction(
  '[PUNTO-POSTE-MANAGEMENT] - get board list success',
  props<{ responseBacheca: IResponseBacheca | null }>()
);

